import React, { Component, PropTypes } from 'react';
import PackageSelector from 'pap/containers/common/input_fields/package_selector';

export default class Packages extends Component {
  componentWillMount() {
    const { category, fetchPricing, fetchCategoriesIfNeeded } = this.props;
    fetchPricing(category);
    fetchCategoriesIfNeeded();
  }

  componentWillReceiveProps(nextProps) {
    const { category, fetchPricing } = this.props;
    if (nextProps.category !== category && nextProps.category) {
      fetchPricing(nextProps.category);
    }
  }

  hide() {
  }

  render() {
    const { category, packages } = this.props;

    if (!category || !packages || !packages.length) {
      return (<div className="row columns">Please select a package above</div>);
    }

    return (<PackageSelector
      noEliteConfirmation={true}
      packages={packages}
      {...this.props}
      hideFullScreen={this.hide}
      sendChange={true}
    />);
  }
}

Packages.propTypes = {
  fetchPricing: PropTypes.func.isRequired,
  fetchCategoriesIfNeeded: PropTypes.func.isRequired,
  category: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  packages: PropTypes.array,
};
